import type { EtapaOps, PrioridadeOps } from '@pgcustom/shared-types';
import { ETAPAS_OPS } from '@pgcustom/shared-types';

/** Rótulos compartilhados entre o quadro e o detalhe — mesmo padrão de `pedidos/status-pedido.ts`. */
export const ETAPAS_ROTULO: Array<{ valor: EtapaOps; rotulo: string }> = [
  { valor: 'recebido', rotulo: 'Recebido' },
  { valor: 'pintura', rotulo: 'Pintura' },
  { valor: 'montagem', rotulo: 'Montagem' },
  { valor: 'testes', rotulo: 'Testes' },
  { valor: 'embalagem', rotulo: 'Embalagem' },
  { valor: 'enviado', rotulo: 'Enviado' },
];

export function rotuloEtapa(valor: EtapaOps): string {
  return ETAPAS_ROTULO.find((opcao) => opcao.valor === valor)?.rotulo ?? valor;
}

export const PRIORIDADES_ROTULO: Array<{ valor: PrioridadeOps; rotulo: string; tone: 'neutro' | 'alerta' | 'erro' }> = [
  { valor: 'baixa', rotulo: 'Baixa', tone: 'neutro' },
  { valor: 'normal', rotulo: 'Normal', tone: 'neutro' },
  { valor: 'alta', rotulo: 'Alta', tone: 'erro' },
];

export function rotuloPrioridade(valor: PrioridadeOps): string {
  return PRIORIDADES_ROTULO.find((opcao) => opcao.valor === valor)?.rotulo ?? valor;
}

export function toneDaPrioridade(valor: PrioridadeOps): 'neutro' | 'alerta' | 'erro' {
  return PRIORIDADES_ROTULO.find((opcao) => opcao.valor === valor)?.tone ?? 'neutro';
}

export { ETAPAS_OPS };
